// extracted by mini-css-extract-plugin
module.exports = {"container":"calendar-kpis_container__qc6H6","row":"calendar-kpis_row__2fL8z"};